

export default function Config () {
  // States
  
  return (
    <div><h1>CONFIG</h1></div>
  );
};

